import { inject } from '@angular/core';
import { TeacherApiService } from '@shared/services';
import { PopoverConfig, PopoverConfigFactory, PopoverHandlerConfig } from '../generic-popover.interfaces';
import { defaultCancelAction, defaultConfirmAction } from './default-actions';
import { teacherLevelFormPopoverConfig } from '@shared/components/edit-create-form/configs/teacher-level.form.popover.config';

export const teacherLevelPopoverConfig: PopoverConfigFactory = (
  onSuccess: () => void,
  onCancel: () => void,
  actionHandlers?: Record<string, (popoverConfig: PopoverHandlerConfig, formValue: any) => void | Promise<any>>
): PopoverConfig => {
  const teacherApiService = inject(TeacherApiService);

  return {
    width: '650px',
    title: 'Chỉnh sửa cấp độ giáo viên',
    dismissable: true,
    styleClass: 'p-fluid',
    formConfig: teacherLevelFormPopoverConfig(),
    actions: [defaultCancelAction, defaultConfirmAction],
    actionHandlers,
    handlerConfig: {
      service: teacherApiService,
      method: 'updateTeacherLevel',
      entityLabel: 'cấp độ giáo viên',
      commonDataTransform: (formValue: any) => ({
        id: formValue.id,
        teacherId: formValue.teacherId,
        type: formValue.type,
        courseLevelId: formValue.courseLevelId,
        status: formValue.status,
        priority: formValue.priority ? parseInt(formValue.priority) : null,
        note: formValue.note
      }),
      onSuccess,
      onCancel
    }
  };
};
